
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function Terms() {
  const { t } = useTranslation();

  useEffect(() => {
    // 页面加载后自动滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Terms of Service - Flidge",
      "description": "Terms of Service for Flidge game localization platform",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/terms`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "Flidge",
        "url": import.meta.env.VITE_SITE_URL || "https://example.com"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <main className="pt-24 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
            {t('termsTitle')}
          </h1>
          
          <article className="prose prose-invert max-w-none">
            <p className="text-gray-300 text-lg mb-8 text-center">
              {t('termsLastUpdated')}
            </p>
            
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms1Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms1Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms2Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms2Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms3Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms3Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms4Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms4Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms5Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms5Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms6Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms6Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms7Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms7Content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4 text-white">{t('terms8Title')}</h2>
                <p className="text-gray-300 leading-relaxed">
                  {t('terms8Content')}
                </p>
              </section>
            </div>
          </article>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
